import Container from "react-bootstrap/esm/Container";

const About = () => {
  return (
    <Container className="my-5">
      <div>
        <h1 className="text-warning text-center">BIO</h1>
        <p className="text-light text-center">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates
          minus dolores vitae at reiciendis suscipit quis ut praesentium odit
          iusto. Ducimus modi eos architecto hic ea numquam deleniti nemo qui
          illum atque eaque veniam, cupiditate consectetur placeat perferendis,
          culpa laboriosam? Harum nobis aspernatur nulla est modi provident hic
          placeat dignissimos.
        </p>
      </div>
      <div className="history my-5">
        <div>
          <h5 className="text-primary">Hyundai Assan</h5>
          <p className="text-light">
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Laboriosam
            impedit quisquam sint atque voluptate aliquid totam similique? Eos,
            accusamus aspernatur!
          </p>
        </div>
        <div>
          <h5 className="text-primary">Hyundai Assan</h5>
          <p className="text-light">
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Laboriosam
            impedit quisquam sint atque voluptate aliquid totam similique? Eos,
            accusamus aspernatur!
          </p>
        </div>
        <div>
          <h5 className="text-primary">Hyundai Assan</h5>
          <p className="text-light">
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Laboriosam
            impedit quisquam sint atque voluptate aliquid totam similique? Eos,
            accusamus aspernatur!
          </p>
        </div>
      </div>
    </Container>
  );
};

export default About;
